import React, { Component, PropTypes } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';

import './tenantsList.scss';

import tenantsStore from 'storeState/tenants';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import ATable from "views/aTable/ATable";
import Button from "views/button/Button";
import Loading from "views/loading/Loading";

import {formatDateTime} from 'service/LocaleService';
import _ from "lodash";
import URLService from "../../../service/URLService";

export class TenantsList extends Component {

    static contextTypes = {
        intl: PropTypes.object
    }

    componentDidMount() {
        this.props.actions.tenantsListRequest();
    }

    onTenantClick = (tenant_id) => {
        if(this.props.onTenantSelect) {
            this.props.onTenantSelect(tenant_id);
        }
    }

    render() {
        return (
            <div className={`tenants-list`}>
              <Loading finished={this.props.tenants!=null} render={(() =>
                <ATable>
                  <tbody>
                  <tr>
                    <th><FormattedMessage id="tenantsList.name" defaultMessage="Name" /></th>
                    <th><FormattedMessage id="tenantsList.created_at" defaultMessage="Created at" /></th>
                  </tr>
                  <For each="tenant" of={this.props.tenants}>
                    <tr className={`clickable ${tenant.id === URLService.getQueryParameterAsString("tenant_id") ? 'selected': ''}`} onClick={() => this.onTenantClick(tenant.id)}>
                      <td>{tenant.name}</td>
                      <td>{formatDateTime(tenant.created_at)}</td>
                    </tr>
                  </For>
                  <If condition={_.size(this.props.tenants) === 0}>
                    <tr>
                      <td colSpan={2}><FormattedMessage id="tenantsList.empty.message" defaultMessage="No Tenants" /></td>
                    </tr>
                  </If>
                  </tbody>
                </ATable>
              ).bind(this)} />
            </div>
        );
    }
}


export default connect((state, props) => {
  return {
    tenants: tenantsStore.selectors.tenantsList(state)
  }
},(dispatch, props) => {
  return {
    actions: bindActionCreators(Object.assign({}, tenantsStore.actions), dispatch)
  }
})(TenantsList)



// WEBPACK FOOTER //
// ./src/components/views/tenantsList/TenantsList.js